import React from 'react'

import getID from '../../common/helpers/getID'

export interface useIDProps {
  id?: string | undefined
}

function useID({ id: propId }: useIDProps) {
  const [id, setID] = React.useState(() => propId || getID())

  React.useEffect(() => {
    setID(propId || getID())
  }, [propId])

  return id
}

export default useID
